import client from '@common/utils/rest';
import { FoldersActions, FORMATS } from '../const/ActionsConst';
import { getQueriesAsSearch } from '@common/utils';

const URL_PREFIX = 'api/folders';

const FORMATS_FOLDERS_CONFIG = {
    [FORMATS.datasheet.individual]: {
        path: '/ds',
        queries: {
            context: 1,
        }
    },
    [FORMATS.datasheet.pedigree]: {
        path: '/ds',
        queries: {
            context: 2
        }
    },
    [FORMATS.spreadsheet.individual]: {
        path: '/ss',
        queries: {
            context: 1
        }
    },
    [FORMATS.subtext]: {
        path: '/subtext',
    },
    [FORMATS.symbols]: {
        path: '/symbols',
    },
    [FORMATS.pedigreeDropFields]: {
        path: '/dropfields',
    },
};

export const getFormatFolders = (type) => (dispatch) => {
    const { path, queries } = FORMATS_FOLDERS_CONFIG[type];
    const finalPath = `${URL_PREFIX}/formats${path}${getQueriesAsSearch(queries)}`;

    client({
        path: finalPath,
        method: 'GET'
    }).then(
        (response) => {
            dispatch({
                type: FoldersActions.SAVE_FORMAT_FOLDERS,
                payload: response.entity,
            });
        },
        error => {console.error('getFormatFolders: ', error);}
    );
};

export const clearFormatFolders = () => ({
    type: FoldersActions.CLEAR_FORMAT_FOLDERS,
});